export default {
  ACCEPT_COLLABORATION_INVITE: 'accept_collaboration_invite',
  ADD_DOCUMENT: 'add_document',
  ADD_GUEST_USER: 'add_guest_user',
  ADD_INTEGRATION: 'add_integration',
  ADD_PAYMENT_INFO: 'add_payment_info',
  ADD_PHOTO: 'add_photo',
  ANNOTATE_PHOTO: 'annotate_photo',
  ASSIGN_PROJECT: 'assign_project',
  CAMERA_OPTION: 'camera_option',
  CAMERA_SESSION_STARTED: 'camera_session_started',
  CANCEL_ABANDON: 'cancel_abandon',
  CANCEL_ACCOUNT: 'cancel_account',
  CANCEL_CONFIRM: 'cancel_confirm',
  CANCEL_OPEN_MODAL: 'cancel_open_modal',
  COMMENT: 'comment',
  COMPLETE_REGISTRATION: 'complete_registration',
  CREATE_BEFORE_AFTER: 'create_before_after',
  CREATE_COLLABORATION_INVITE: 'create_collaboration_invite',
  CREATE_PROJECT: 'create_project',
  CREATE_SNIPPET: 'create_snippet',
  DEACTIVATE_USER: 'deactivate_user',
  DEEP_LINK_SIGNUP: 'deep_link_signup',
  DELETE_PROJECT: 'delete_project',
  DESCRIPTION_SAVED: 'description_saved',
  DISMISS_ONBOARDING_MODAL: 'dismiss_onboarding_modal',
  DOWNGRADE_PLAN: 'downgrade_plan',
  DOWNLOAD_REPORT_PDF: 'download_report_pdf',
  EDITOR_ACTION: 'editor_action',
  EDITOR_START: 'editor_start',
  EXPERIENCE_ONBOARD: 'experience_onboard',
  EXPORT_TASKLIST_PDF: 'export_tasklist_pdf',
  FILTER: 'filter',
  GENERATE_TEAM_INVITE_LINK: 'generate_team_invite_link',
  GRANT_CAMERA_ACCESS: 'grant_camera_access',
  GRANT_LOCATION_ACCESS: 'grant_location_access',
  GRANT_NOTIFICATION_ACCESS: 'grant_notification_access',
  GRANT_PHOTO_ACCESS: 'grant_photo_access',
  INVITE_USER: 'invite_user',
  LABEL_PROJECT: 'label_project',
  LOGIN: 'login',
  REGISTRATION_PROGRESS: 'registration_progress',
  RENAME_PROJECT: 'rename_project',
  SAVE_PROJECT_NOTE: 'save_project_note',
  SCAN_DOCUMENT: 'scan_document',
  SELECT_ONBOARDING_PATH: 'select_onboarding_path',
  SHARE_BEFORE_AFTER: 'share_before_after',
  SHARE_GALLERY: 'share_gallery',
  SHARE_PHOTO: 'share_photo',
  SHARE_REFERRAL_LINK: 'share_referral_link',
  SHARE_TEAM_INVITE_LINK: 'share_team_invite_link',
  SHARE_TIMELINE: 'share_timeline',
  SHOWCASE_PROJECT_CREATE: 'showcase_project_create',
  SHOWCASE_PROJECT_DELETE: 'showcase_project_delete',
  SHOWCASE_PROJECT_EDIT: 'showcase_project_edit',
  SHOWCASE_PROJECT_EXIT: 'showcase_project_exit',
  SHOWCASE_PROJECT_HIDE_PHOTOS: 'showcase_project_hide_photos',
  SHOWCASE_PROJECT_HIDE_PROJECT: 'showcase_project_hide_project',
  SKIP_ONBOARDING: 'skip_onboarding',
  STAR: 'star',
  START_REGISTRATION: 'start_registration',
  START_TRIAL: 'start_trial',
  SWITCH_PAYMENT_METHOD: 'switch_payment_method',
  TAG: 'tag',
  TAKE_PHOTO: 'take_photo',
  TAKE_VIDEO: 'take_video',
  TAP_HOME_EMPTY_STATE: 'tap_home_empty_state',
  TAP_HOME_NEARBY_PROJECTS: 'tap_home_nearby_projects',
  TAP_HOME_TOP_ACTION: 'tap_home_top_action',
  TAP_INVITE_USER_CTA: 'tap_invite_user_cta',
  TAP_REFER: 'tap_refer',
  UPDATE_PAYMENT_INFO: 'update_payment_info',
  UPGRADE_PLAN: 'upgrade_plan',
  VIEW_ASSET_DETAILS: 'view_asset_details',
  VIEW_BILLING_SCREEN: 'view_billing_screen',
  VIEW_EMPTIEST_STATE: 'view_emptiest_state',
  VIEW_ONBOARDING_MODAL: 'view_onboarding_modal',
  VIEW_SCREEN: 'view_screen',
  VIEW_SIGNUP_SCREEN: 'view_signup_screen',
  FACEBOOK: {
    ADD_PAYMENT_INFO: 'AddPaymentInfo',
    COMPLETE_REGISTRATION_MOBILE: 'fb_mobile_complete_registration',
    COMPLETE_REGISTRATION_WEB: 'CompleteRegistration',
  },
  REFERRAL_ANNOUNCEMENT: {
    DISMISS: 'dismiss_referral_announcement',
    TAP_CTA: 'tap_referral_announcement_cta',
    VIEW: 'view_referral_announcement',
  },
  REPORTS: {
    ADD_PHOTO: 'report_add_photo',
    ADDING_SNIPPET_OVERLAPS_CHAR_LIMIT:
      'adding_snippet_overlaps_description_limit',
    BULK_REARRANGE_NEW_SECTION: 'bulk_rearrange_to_new_section',
    BULK_REARRANGE: 'bulk_rearrange_within_section',
    CREATE_REPORT_FROM_TEMPLATE: 'create_report_from_template',
    CREATE_REPORT: 'create_report',
    CREATE_SECTION: 'create_section',
    CREATE_SUMMARY: 'create_summary',
    DELETE_TEMPLATE: 'report_delete_template',
    DISPLAY_SECTION_TITLE: 'report_display_section_title',
    EDIT_TEMPLATE: 'report_edit_template',
    LOAD_PHOTO_COMMENT: 'report_load_photo_comment',
    LOAD_PHOTO_DESCRIPTION: 'report_load_photo_description',
    PREVIEW_TEMPLATE: 'report_preview_template',
    REPORT_INSERT_SNIPPET: 'report_insert_snippet',
    SELECTED_PAGE_LAYOUT: 'selected_page_layout',
    SHARE_REPORT: 'share_report',
    SINGLE_REARRANGE: 'single_rearrange_within_section',
    TAKE_PHOTO: 'report_take_photo',
    VIEW_REPORT: 'view_report',
  },
  TASK_LISTS: {
    ADD_REFERENCE_IMAGE: 'todolist_add_reference_image',
    CREATE_LIST: 'todolist_create_todolist',
    CREATE_SECTION: 'todolist_create_section',
    CREATE_TASK: 'todolist_create_task',
    IMPORT_TASK_PHOTO: 'todolist_import_task_photo',
    REARRANGE_SECTIONS: 'todolist_rearrange_sections',
    REARRANGE_TASKS: 'todolist_rearrange_tasks',
    SHARE_PDF: 'todolist_share_pdf',
    TAKE_TASK_PHOTO: 'todolist_take_task_photo',
    VIEW_PDF: 'todolist_view_pdf',
    VIEW_REFERENCE_IMAGES: 'todolist_view_reference_images',
    VIEW_MULTISELECT_EDITOR: 'todolist_view_multiselect_editor',
    CANCEL_MULTISELECT: 'todolist_cancel_multiselect',
    EDIT_MULTISELECT: 'todolist_edit_multiselect',
  },
  TASK_LIST_TEMPLATES: {
    ADD_REFERENCE_IMAGE: 'todolist_template_add_reference_image',
    CREATE_TEMPLATE: 'todolist_create_template',
    DELETE_TEMPLATE: 'todolist_delete_template',
    PREVIEW_TEMPLATE: 'todolist_preview_template',
    SAVE_TEMPLATE: 'todolist_save_template',
    USE_TEMPLATE: 'todolist_use_template',
    VIEW_MULTISELECT_EDITOR: 'todolist_template_view_multiselect_editor',
    CANCEL_MULTISELECT: 'todolist_template_cancel_multiselect',
    EDIT_MULTISELECT: 'todolist_template_edit_multiselect',
  },
  TODOS_MARKETPLACE: {
    VIEW_SCREEN: 'view_todolist_marketplace_screen',
  },
  CONNECTIVITY: {
    POTENTIAL_DIP_DETECTED: 'potential_dip_detected',
    POTENTIAL_STATUS_CHANGE: 'potential_status_change',
    CONNECTION_STABILITY_CHANGED: 'connection_stability_changed',
    CONNECTION_STATUS_CHANGED: 'connection_status_changed',
  },
};
